// this files contains the templates for the e2e form tests

export const formTemplate = ({ novalidate }: { novalidate: "form" | "button" | false }) => `
        <ux-form>
            <form method="post" action="#" ${novalidate === "form" ? `novalidate` : ``}>
                <ux-input-field
                    label="test"
                    type="text"
                    name="test"
                    placeholder="test"
                    required
                    input-id="1"
                    data-validation-required--msg="This field is required"
                ></ux-input-field>
                <ux-input-field
                    label="email"
                    type="email"
                    name="email"
                    input-id="2"
                    value="invalidEmail"
                    required
                    data-validation-required--msg="This field is required"
                ></ux-input-field>
                <button id="submit" type="submit" ${novalidate === "button" ? `formnovalidate` : ``}>
                    Submit
                </button>
            <form>
        </ux-form>
`;

export const templateWithStaticFilter = () => {
    return `
    <ux-form>
        <form method="post" action="#">
            <ux-static-filter display-all-values="machine=">
                <ux-form-group name="machine">
                    <ux-dropdown>
                        <ux-radio-list-item label="choice 1" name="machine" value="" checked></ux-radio-list-item>
                        <ux-radio-list-item label="choice 2" name="machine" value="1"></ux-radio-list-item>
                        <ux-radio-list-item label="choice 3" input-id="3" name="machine" value="2"></ux-radio-list-item>
                    </ux-dropdown>
                </ux-form-group>
                <ux-input-field
                    label="test"
                    type="text"
                    name="test"
                    placeholder="test"
                    input-id="1"
                    required
                    data-validation-required--msg="This field is required"
                ></ux-input-field>
                <div class="one" data-ux-static-filter="machine=1">
                    <ux-input-field
                        label="email"
                        type="email"
                        name="email"
                        input-id="2"
                        value="invalidEmail"
                        required
                        data-validation-required--msg="This field is required"
                    ></ux-input-field>
                </div>
            </ux-static-filter>
            <button id="submit" type="submit">
                Submit
            </button>
        </form>
    </ux-form>
    `;
};

export const templateWithAddressSwitch = () => {
    return `
        <ux-form>
            <form method="post" action="#">
                <ux-input-field value="test" name="test">
                </ux-input-field>
            </form>
        </ux-form>
    `;
};

export const formWithMultipleElements = () => {
    return `
        <ux-form>
            <form method="post" action="#">
                <ux-select
                    label="label"
                    name="select"
                >
                    <option value="">Option 1</option>
                    <option value="option2">Option 2</option>
                    <option value="option3">Option 3</option>
                </ux-select>
                <ux-input-field
                    required
                    label="label"
                    type="text"
                    name="input"
                    data-validation-required--msg="This field is required"
                    data-validation-invalid--msg="This field is invalid"
                ></ux-input-field>
                <ux-checkbox
                    label="label"
                    value="value"
                    name="checkbox"
                    required
                    data-validation-required--msg="This checkbox is required"
                ></ux-checkbox>
                <ux-phone-input
                    name="phone"
                    language="de"
                    label="Telefonnummer"
                    country="DE"
                    required
                    data-validation-required--msg="This phone input is required"
                    data-validation-invalid--msg="This phone input is invalid"
                ></ux-phone-input>
                <ux-textarea-field
                    name="textarea"
                    label="label"
                    required
                    data-validation-required--msg="This field is required"
                ></ux-textarea-field>
                <button id="submit" type="submit">
                    Submit
                </button>
            </form>
        </ux-form>
    `;
};

export const greenMarketFormFirstStep = () => {
    return `
<ux-form async="false" additional-scroll-offset="40">
    <form method="POST" action="#">
        <div>
            <div>
                <ux-radio-button label="1010 3000x1100" name="format" value="1"
                    checked="true" with-border as-box>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button label="1020 3000x1200" name="format" value="2"
                    checked="false" with-border as-box>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button label="1030 3000x1300" name="format" value="3"
                    checked="false" with-border as-box>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button label="1040 3000x1400" name="format" value="4"
                    checked="false" with-border as-box>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div class="gr-12 ux-u-margin-top-20">
                <span class="ux-label">Select your laser power *</span>
            </div>
            <div>
                <ux-radio-button label="5 kW" name="power" value="5" checked="true"
                    with-border as-box>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button label="6 kW" name="power" value="6" checked="false"
                    with-border as-box>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button label="7 kW" name="power" value="7" checked="false"
                    with-border as-box>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button label="8 kW" name="power" value="8" checked="false"
                    with-border as-box>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button name="machine" value="9" checked="true" with-border>
                    <div slot="media">
                        <picture>
                            <source src="#" media="(max-width: 567px)" />
                            <source src="#" />
                            <img src="#" alt="#" />
                        </picture>
                    </div>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <ux-radio-button name="machine" value="10" checked="false" with-border>
                    <div slot="media">
                        <picture>
                            <source src="#" media="(max-width: 567px)" />
                            <source src="#" />
                            <img src="#" alt="#" />
                        </picture>
                    </div>
                    <div slot="description">
                        Information
                    </div>
                </ux-radio-button>
            </div>
            <div>
                <div class="ux-button-group-inverted">
                    <button type="submit" class="ux-button ux-button--green">
                        Next
                    </button>
                </div>
            </div>
        </div>
    </form>
</ux-form>
    `;
};

export const greenMarketFormSecondStep = () => {
    return `
<ux-form async="false" additional-scroll-offset="40">
    <form method="POST" action="./#">
        <div>
            <div>
                <ux-select required label="salutation" name="salutation-delivery" full-width>
                    <option value="">Please select</option>
                    <option value="ms" selected>Ms</option>
                    <option value="mr">Mr</option>
                </ux-select>
            </div>
            <div>
                <ux-input-field required label="first name" type="text" name="first-name-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-input-field required label="last name" type="text" name="last-name-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-input-field required label="company name" type="text" name="company-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-input-field required label="street name and house number" type="text"
                    name="street-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-input-field label="unit/further information" type="text"
                    name="unit-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-input-field required label="town/city" type="text" name="city-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-input-field required label="zip" type="number" name="zip-delivery">
                </ux-input-field>
            </div>
            <div>
                <ux-select required label="country" name="country-delivery" full-width>
                    <option value="">Please select</option>
                    <option value="de" selected>Germany</option>
                    <option value="in">India</option>
                </ux-select>
            </div>
            <div>
                <ux-phone-input required language="de" label="phone number" country="DE"
                    name="phone-delivery">
                </ux-phone-input>
            </div>
            <div>
                <ux-input-field required label="email" type="email" name="email-delivery">
                </ux-input-field>
            </div>
            <ux-static-filter>
                <div>
                    <div>
                        <ux-form-group required name="delivery-address">
                            <ux-radio-button checked="true" name="delivery-address" value="1"
                                label="same as billing address" checked>
                            </ux-radio-button>
                            <ux-radio-button name="delivery-address" value="2"
                                label="different address">
                            </ux-radio-button>
                        </ux-form-group>
                    </div>
                    <div data-ux-static-filter="delivery-address=2">
                        <div>
                            <ux-select required label="salutation" name="salutation-billing"
                                full-width>
                                <option value="">Please select</option>
                                <option value="ms">Ms</option>
                                <option value="mr">Mr</option>
                            </ux-select>
                        </div>
                        <div>
                            <ux-input-field required label="first name" type="text"
                                name="first-name-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-input-field required label="last name" type="text"
                                name="last-name-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-input-field required label="company name" type="text"
                                name="company-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-input-field required label="street name and house number" type="text"
                                name="street-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-input-field label="unit/further information" type="text"
                                name="unit-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-input-field required label="town/city" type="text"
                                name="city-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-input-field required label="zip" type="number" name="zip-billing">
                            </ux-input-field>
                        </div>
                        <div>
                            <ux-select required label="country" name="country-billing" full-width>
                                <option value="">Please select</option>
                                <option value="de">Germany</option>
                                <option value="in">India</option>
                            </ux-select>
                        </div>
                        <div>
                            <ux-phone-input required language="de" label="phone number" country="DE"
                                name="phone-billing">
                            </ux-phone-input>
                        </div>
                        <div>
                            <ux-input-field required label="email" type="email" name="email-billing">
                            </ux-input-field>
                        </div>
                    </div>
                </div>
            </ux-static-filter>
        </div>
        <div>
            <div class="ux-button-group-inverted">
                <button type="submit" class="ux-button">
                    Next step
                </button>
                <button class="ux-button" formnovalidate formaction="previous-step-url">
                    Previous
                </button>
            </div>
        </div>
    </form>
</ux-form>
    `;
};

export const formGroupRadioButtons = () => {
    return `
    <ux-form-group
        label="Select an option"
        required
        name="option"
        data-validation-required--msg="This field is required"
    >
        <ux-radio-button
            name="r2"
            label="Option 1"
            value="Option 1"
        ></ux-radio-button>
        <ux-radio-button
            name="r2"
            label="Option 2"
            value="Option 2"
        ></ux-radio-button>
        <ux-radio-button
            name="r3"
            label="Option 3"
            value="Option 3"
        ></ux-radio-button>
    </ux-form-group>
    `;
};

export const formGroupCheckboxes = () => {
    return `
    <ux-form-group
        label="Checkbox group"
        required
        name="use-case"
        data-validation-group--min="2"
        data-validation-group--max="4"
        data-validation-group--msg="Select between 2 and 4 cases"
    >
        <ux-checkbox
            label="Use case 1"
            value="1"
            name="use-case"
        ></ux-checkbox>
        <ux-checkbox
            label="Use case 2"
            value="2"
            name="use-case"
        ></ux-checkbox>
        <ux-checkbox
            label="Use case 3"
            value="3"
            name="use-case"
        ></ux-checkbox>
        <ux-checkbox
            label="Use case 4"
            value="4"
            name="use-case"
        ></ux-checkbox>
        <ux-checkbox
            label="Use case 5"
            value="5"
            name="use-case"
        ></ux-checkbox>
    </ux-form-group>
    `;
};
